import React, { Component } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"

class MonthlyEarnings extends Component {
  constructor(props) {
    super(props)

    // Dummy data for platform review counts
    const reviewCounts = {
      Facebook: Math.floor(Math.random() * 1000 + 500),
      Instagram: Math.floor(Math.random() * 1000 + 500),
      Healthgrade: Math.floor(Math.random() * 500 + 100),
      Yelp: Math.floor(Math.random() * 500 + 100),
    }

    const currentMonth = new Date().toLocaleString("default", { month: "long" })

    this.state = {
      currentMonth,
      reviewCounts,
      options: {
        colors: ["#28bbe3", "#F0F1F4"],
        chart: {
          stacked: true,
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            columnWidth: "70%",
          },
        },
        grid: {
          borderColor: "#f8f8fa",
          row: {
            colors: ["transparent", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },

        xaxis: {
          categories: ["Facebook", "Instagram", "Healthgrade", "Yelp"],
          labels: {
            formatter: function (val) {
              return val
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          title: {
            text: undefined,
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            },
          },
        },
        fill: {
          opacity: 1,
        },

        legend: {
          show: false,
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },
      },
      series: [
        {
          name: "Reviews",
          data: [
            reviewCounts.Facebook,
            reviewCounts.Instagram,
            reviewCounts.Healthgrade,
            reviewCounts.Yelp,
          ],
        },
      ],
    }
  }
  render() {
    const { currentMonth, reviewCounts } = this.state
    return (
      <React.Fragment>
        <Card>
          <CardBody>
            <h4 className="card-title mb-4">
              {currentMonth} Platform Review Counts
            </h4>

            <Row className="text-center mt-4">
              <Col xs="3">
                <h5 className="font-size-20">{reviewCounts.Facebook}</h5>
                <p className="text-muted">Facebook</p>
              </Col>
              <Col xs="3">
                <h5 className="font-size-20">{reviewCounts.Instagram}</h5>
                <p className="text-muted">Instagram</p>
              </Col>
              <Col xs="3">
                <h5 className="font-size-20">{reviewCounts.Healthgrade}</h5>
                <p className="text-muted">Healthgrade</p>
              </Col>
              <Col xs="3">
                <h5 className="font-size-20">{reviewCounts.Yelp}</h5>
                <p className="text-muted">Yelp</p>
              </Col>
            </Row>

            <div
              id="morris-bar-stacked"
              className="morris-charts morris-charts-height"
              dir="ltr"
            >
              <ReactApexChart
                options={this.state.options}
                series={this.state.series}
                type="bar"
                height="290"
              />
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

export default MonthlyEarnings
